export default "__VITE_ASSET__BXzpx1zo__"